<ion-card *ngIf="document.detailLines.length > 0">

<ion-card-content  (click)="openModalPayment()" *ngIf="document.deposit">
    <ion-label> {{ document.deposit.amount ? "Amount Paid: " + ((document.deposit.amount - document.deposit.change) | currency: 'EUR') : "Payment"}} </ion-label>
</ion-card-content>

</ion-card>
